import { Button } from '@innovationnorway/cl-react';
import DialogContainer from 'src/components/DialogContainer/DialogContainer';
import DialogActions from 'src/components/DialogActions/DialogActions';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { TimeEntryDto, TimeEntryStatus } from 'src/api/v2';
import useTimeEntries from 'src/hooks/use-time-entries';
import { toastPromise } from 'src/utils/toast';

type Props = {
  show: boolean;
  selectedTimeEntries: TimeEntryDto[];
  onClose: () => void;
};

const DeleteInkindModal: React.FC<Props> = ({ show, selectedTimeEntries, onClose }) => {
  const { t: tCommon } = useTranslation();
  const { t: tSelfEffort } = useTranslation('selfEffort');

  const { deleteTimeEntryMutation } = useTimeEntries();

  const approvedNumberMemo: number = useMemo(() => {
    return selectedTimeEntries.filter((x) => x.status === TimeEntryStatus.Counting).length;
  }, [selectedTimeEntries]);

  const deleteEntries = () => {
    const promise = deleteTimeEntryMutation.mutateAsync(selectedTimeEntries.map((timeEntry) => timeEntry.id));

    toastPromise(promise, {
      pending: `${tCommon('deleting')}...}`,
      success: `${selectedTimeEntries.length} ${tCommon('deleted')}.`,
      error: tSelfEffort('couldNotDelete'),
    }).then(() => {
      onClose();
    });
  };

  return (
    <DialogContainer show={show} onClose={onClose} title={tSelfEffort('deleteSelfEffort')}>
      <div>
        {approvedNumberMemo > 0 && (
          <p>
            {approvedNumberMemo === 1
              ? tSelfEffort('numberOfApprovedRows_one')
              : tSelfEffort('numberOfApprovedRows_many', { approvedNumber: approvedNumberMemo })}
          </p>
        )}
        <p>{tSelfEffort('deleteAreYouSure')}</p>
      </div>
      <DialogActions className="justify-content--space-between padding-top--3">
        <Button
          type="button"
          onClick={onClose}
          disabled={deleteTimeEntryMutation.isLoading}
          variant="secondary"
        >
          {tCommon('cancel')}
        </Button>

        <Button
          type="button"
          data-color={'danger' as const}
          onClick={deleteEntries}
          disabled={deleteTimeEntryMutation.isLoading}
        >
          {tCommon('delete')}
        </Button>
      </DialogActions>
    </DialogContainer>
  );
};

export default DeleteInkindModal;
